import React, { useEffect, useState } from 'react'
import { emptyStateText } from '../../constants'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'
import Loader from '../../../../../components/Loader'
import { get, put } from '../../../../../lib/api'
import EmptyState from '../emptyState'
import { useDidUpdate } from '../../../../../lib/customHooks'
import { CongratulationsCard, AcknowledgementCard } from './notificationCard'
import { FullScreenNotice } from '../../../../../components/Popup'
import { descriptionText } from '../../constants'
import { convertUrlToHttps } from '../../../../../lib/utils'
import GenericError from '../../../../../components/GenericError'
import { useInfiniteScroll } from '../../../../../lib/customHooks'
import { menuItemObj } from '../../../../../components/PrivatePage'
import { Box, Image, Text} from '../../../../../designSystem'

const SingleBook = styled.div`
  display: flex;
  padding: 24px;
  margin-bottom: 8px;
  background-color: var(--Dove);
  cursor: pointer;
  flex-direction: row;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(73, 83, 89, 0.16);
  }

  @media (max-width:600px){
    padding: 16px;
    flex-direction: column;
  }
`
const ThumbnailDiv = styled.div`
  margin-right: 24px;
  width: 144px;
  height: 144px;
  background-color: var(--Grey900);
  box-shadow: 0 4px 8px 0 rgba(73, 83, 89, 0.16);
  border-radius: 4px;
`
const Thumbnail = styled.img`
  width 144px;
  height: 144px;
  border-radius: 4px;
`
const Details = styled.div`
  // width: 60%;
`
const Title = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--Text700);
  margin-bottom: 16px;
`
const RequirementDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  max-width: 380px;
`
const Requirement = styled.div`
  width: 190px;
  border-radius: 4px;
  background-color: rgba(242, 198, 2, 0.2);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  color: var(--Corn800);
  padding: 8px 16px;
  margin-right: 16px;
  border-radius: 24px;

  @media (max-width:600px){
    &:first-child {
      margin-bottom: 8px;
    }
  }
`

const LoaderDiv = styled.div`
  padding-top: 50px;
  height: 100vh;
  background-color: var(--Dove);
`
const FilterContainer = styled.div`
  padding: 8px;
  display: flex;
  background-color: var(--Dove);
`
const FilterSingle = styled.div`
  min-width: 50px;
  text-align: center;
  margin-right: 8px;
  border-radius: 24px;
  border: ${({ selected }) => (selected ? 'none' : 'solid 1px var(--Text300)')};
  padding: 6px 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.33;
  cursor: pointer;
  color: ${({ selected }) =>
    selected ? 'var(--TextDark700)' : 'var(--Text500)'};
  background-color: ${({ selected }) =>
    selected ? 'var(--Text300)' : 'transparent'};
`
const Participants = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  color: var(--Text500);
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media(max-width:600px){
    justify-content: flex-start;
    margin: 16px;
  }
`
const ParticipantImage = styled.img`
  height: 32px;
  width: 32px;
  display: inline-block;
  border: solid 2px var(--Dove);
  border-radius: 50%;
  margin-left: -12px;
  &:last-of-type {
    margin-right: 8px;
  }
`
export const TNCPara = styled.p`
  margin-bottom: 16px;
`
export const TNCTitle = styled.div`
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--Text500);
  margin-bottom: 16px;
`
export const TNCContent = styled.div`
  p {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    color: var(--Text500);
  }
`
const filterCategories = [
  { id: '543da31769d507f225837e88f07289d87b3cdb3d', name: 'Romantic' },
  {
    id: 'f1ba9800b7437863a73946c158d3fda9d667eb49',
    name: 'Suspense and Thriller',
  },
  { id: '66c31aa195de73f7a0be5fe9a0b641387caecde4', name: 'Horror' },
]
const otherFilters = ['New', 'Ending Soon']

const Auditions = ({ history }) => {
  const [isAllSelected, setAllSelected] = useState(true)
  const [categoriesSelected, setCategories] = useState([])
  const [otherFiltersSelected, setOtherFilters] = useState('')
  const [
    isAlreadyParticipatedSelected,
    setAlreadyParticipatedSelected,
  ] = useState(false)

  const [isLoading, setIsLoading] = useState(true)
  const [books, setBooks] = useState(null)
  const [selectedForBooks, setSelectedForBooks] = useState([])
  const [AcceptedBooks, setAcceptedBooks] = useState([])
  const [isTNCPopupShown, setTNCPopupDisplay] = useState(false)
  const [acceptedBookId, setAcceptedBookId] = useState(null)
  const [apiError, toggleApiError] = useState(false)
  const [nextUrl, setNextUrl] = useState(null)
  const isFetching = useInfiniteScroll(fetchMoreData)
  const isMobile = window.screen.width < 600
  const fetchData = () => {
    setIsLoading(true)
    const alreadyParticipated = isAlreadyParticipatedSelected
      ? 'already participated'
      : ''
    const params = {
      categories: categoriesSelected.join(',') || null,
      filter:
        [otherFiltersSelected, alreadyParticipated].filter(Boolean).join(',') ||
        null,
    }
    const auditionBookListApi =
      '/content_api/book.audition_books'
    get(auditionBookListApi, { params: params || {} })
      .then((response) => {
        const { result } = response
        const { books, next_url } = result
        setBooks(books)
        setSelectedForBooks(
          books.filter((book) => book.is_approved && !book.is_accepted)
        )
        setNextUrl(next_url)
        setIsLoading(false)
      })
      .catch((error) => {
        // TODO: remove this hack for failing api
        if (error.code === 400) {
          setBooks([])
        } else {
          throw error
        }
      })
  }

  function fetchMoreData(setIsFetching) {
    if (!nextUrl) {
      setIsFetching(false)
      return
    }
    get(nextUrl)
      .then((response) => {
        const { result } = response
        const { next_url, books: newBooks } = result
        setBooks(books.concat(newBooks))
        setSelectedForBooks(selectedForBooks.concat(newBooks.filter((book) => book.is_approved && !book.is_accepted)))
        setNextUrl(next_url)
        setIsFetching(false)
      })
      .catch((error) => {
        setIsFetching(false)
        throw error
      })
  }

  useEffect(() => {
    fetchData()
  }, [])

  useDidUpdate(() => {
    setIsLoading(false)
  }, [books])

  useDidUpdate(() => {
    fetchData()
  }, [
    isAllSelected,
    categoriesSelected,
    otherFiltersSelected,
    isAlreadyParticipatedSelected,
  ])

  const handleCategoryFilterClick = (val) => {
    if (categoriesSelected.indexOf(val) > -1) {
      setCategories(categoriesSelected.filter((cat) => cat !== val))
    } else {
      setCategories(categoriesSelected.concat(val))
      setAllSelected(false)
    }
  }
  const handleOtherFilterClick = (val) => {
    if (otherFiltersSelected === val) {
      setOtherFilters('')
    } else {
      setAllSelected(false)
      setOtherFilters(val)
    }
  }
  const handleAllFilterClick = () => {
    setCategories([])
    setAlreadyParticipatedSelected(false)
    setOtherFilters('')
    setAllSelected(true)
  }
  const handleAlreadyParticipatedFilterClick = () => {
    if (isAlreadyParticipatedSelected) {
      setAlreadyParticipatedSelected(false)
    } else {
      setAlreadyParticipatedSelected(true)
      setAllSelected(false)
    }
  }
  const handleAcceptBook = () => {
    setTNCPopupDisplay(false)
    // TODO: make accept api call here
    const bookDetailsApi = '/content_api/book.book_auditions'
    get(bookDetailsApi, { params: { book_id: acceptedBookId } })
      .then((response) => {
        const { results } = response
        const { has_participated, auditions = [] } = results
        if (!has_participated) return
        const { audition_id } = auditions[0] || {}
        put('/content_api/book.accept_audition', {
          data: {
            audition_id,
            is_accepted: 1
          },
        })
      })
      .then(() => {
        // on success:
        fetchData()
        setAcceptedBooks(
          books.filter((book) => book.book_id === acceptedBookId)
        )
      })
  }

  const handleAcceptBookPopup = (id) => {
    setAcceptedBookId(id)
    setTNCPopupDisplay(true)
  }

  const handleAckButtonClick = (id) => {
    history.push(`${menuItemObj.audiobooks}?tab=recording-and-production`)
  }

  if (isLoading) {
    return (
      <LoaderDiv>
        <Loader />
      </LoaderDiv>
    )
  }

  const isFiltersApplied = !isAllSelected

  return (
    <>
      <GenericError show={apiError} onClose={() => toggleApiError(false)} />
      {selectedForBooks
        .filter(
          (book) => !AcceptedBooks.find((b) => b.book_id === book.book_id)
        )
        .map(({ book_id, book_title, image_url }) => (
          <CongratulationsCard
            image_url={image_url}
            book_title={book_title}
            key={book_id}
            onAccept={() => handleAcceptBookPopup(book_id)}
            id={book_id}
          />
        ))}
      {AcceptedBooks.map(({ book_id, book_title, image_url }) => (
        <AcknowledgementCard
          image_url={image_url}
          key={book_id}
          book_title={book_title}
          onButtonClick={handleAckButtonClick}
          id={book_id}
        />
      ))}
      <FullScreenNotice
        show={isTNCPopupShown}
        close={() => setTNCPopupDisplay(false)}
        renderActions={
          <>
            <button
              className="action-button"
              type="button"
              onClick={() => setTNCPopupDisplay(false)}
            >
              Cancel
            </button>
            <button
              className="action-button primary-button"
              type="button"
              onClick={handleAcceptBook}
            >
              Accept Audiobook
            </button>
          </>
        }
      >
        <TNCTitle>Terms and Conditions for Company Name</TNCTitle>
        <TNCContent>
          {descriptionText.acceptAudition.map((text, i) => (
            <TNCPara key={'audition-accept-terms-' + i}>{text}</TNCPara>
          ))}
          {descriptionText.acceptConditions.map((text, i) => (
            <p key={'audition-accept-conditions-' + i}>{text}</p>
          ))}
        </TNCContent>
      </FullScreenNotice>
      {/* <FilterContainer>
        <FilterSingle
          selected={isAllSelected}
          onClick={() => handleAllFilterClick()}
        >
          All
        </FilterSingle>
        {filterCategories.map(({ name, id }) => (
          <FilterSingle
            key={id}
            selected={categoriesSelected.indexOf(id) > -1}
            onClick={() => handleCategoryFilterClick(id)}
          >
            {name}
          </FilterSingle>
        ))}
        {otherFilters.map((filter) => (
          <FilterSingle
            key={filter}
            selected={otherFiltersSelected === filter}
            onClick={() => handleOtherFilterClick(filter)}
          >
            {filter}
          </FilterSingle>
        ))}
        <FilterSingle
          selected={isAlreadyParticipatedSelected}
          onClick={() => handleAlreadyParticipatedFilterClick()}
        >
          Already Participated
        </FilterSingle>
      </FilterContainer> */}
      {books.length ? (
        books.map((book) => {
          const requirementArr = (book.audition_info.requirements || '').split(',')
          const req1 = requirementArr[0] || ''
          const req2 = requirementArr[1] || ''
          return (
            <SingleBook
              key={book.book_id}
              onClick={() =>
                history.push(`${menuItemObj.audiobooks}?tab=auditions&id=${book.book_id}`)
              }
            >
              <Box variant="flex" flexDirection="row" justifyContent="flex-start">
                <Image height={[80,144]} width={[80,144]} src={convertUrlToHttps(book.image_url,true)} mr={[8, 24]}/>
                <Box>
                  <Text variant="title" fontWeight="r">{book.book_title}</Text>
                  {!isMobile && book.category_obj.topic_name && <Text mt={8} variant="subtext">{book.category_obj.topic_name}</Text>}
                  <Box variant="flex" mt={8} flexDirection={['column', 'row']}>
                    {req1 && <Requirement>
                      {req1}
                    </Requirement>}
                    {req2 && <Requirement>
                      {req2}
                    </Requirement>}
                  </Box>
                  {/* <RateDiv>{book['audition_info']['base_price']}</RateDiv> */}
                </Box>
              </Box>
              <Box variant="flex"  flexDirection="column" minWidth="23%" ml={!isMobile && 'auto'} mt={[16, 0]}>
                <Text variant="caption" width="100%" bg="surface.sf300" pt={8} pr={16} pb={8} pl={16} borderRadius={4}>
                  Participate before{' '}
                  {book['audition_info']['last_participation_date']}
                </Text>
                <Participants>
                  {book['top_auditions_image_urls'].map((url, i) => (
                    <ParticipantImage
                      src={url}
                      key={'participant-thumbnail' + i}
                    />
                  ))}
                  {`${book['auditions_count'] || 'No'} ${
                    book['auditions_count'] > 1 ? 'Participants' : 'Participant'
                  }`}
                </Participants>
              </Box>
            </SingleBook>
          )
        })
      ) : isFiltersApplied ? (
        <EmptyState
          filtersApplied
          text={'No matching results!'}
          subtext={
            'There were no results matching your creteria, try usig different combination of filters.'
          }
        />
      ) : (
        <EmptyState
          text={emptyStateText['Auditions']['text']}
          subtext={emptyStateText['Auditions']['subtext']}
        />
      )}
      {isFetching && <Loader />}
    </>
  )
}

export default withRouter(Auditions)
